import { IShop } from "./shop.interface";
import { IStatus } from "./status.interface";
import { IUser } from "./user.interface";

export interface IInvoice {
  created_at: string;
  id: number;
  invoice_number: string;
  status: IStatus;
  price: number;
  price_eur: number;
  payment_amount_eur: number;
  shipping_cost: number;
  shipping_cost_per_weight: number;
  sum_price_n_delivery_with_margin: number;
  details: IInvoiceDetail[];
  weight?: number,
  margin?: number,
  date_payment?: string,
  bar_code?:string,
  delivery_option_id?:number
}

export interface IInvoiceDetail {
  id: number;
  invoice_id: number;
  created_at: string;
  margin: string;
  total: string;
  arrived: number;
  order_details: ILoadOrderDetail;
}


export interface ILoadInvoices {
  created_at: string;
  client: IUser;
  id: number;
  invoice_number: string;
  invoice_status_id: number;
  invoice_status: IStatus;
  invoice_details: ILoadInvoiceDetail[];
  price: string;
  price_eur: string;
  payment_amount_eur: string;
  shipping_cost: string;
  shipping_cost_per_weight: string;
  siuntimas_lt: string;
  siuntimas_lt_pvm: string;
  sum_price_n_delivery: string;
  sum_price_n_delivery_with_margin: string;
  weight: string;
  margin: string;
  date_payment?: string,
  bar_code?:string,
  delivery_option_id?:number
}
export interface ILoadInvoiceDetail {
  created_at: string;
  currency_id: number;
  exchange_rate: string;
  id: number;
  invoice_id: number;
  total: string;
  margin: string;
  order_detail_id: number;
  price: string;
  price_per_kg: string;
  shipping_cost: string;
  order_detail: ILoadOrderDetail;
  arrived: string;
  shipping_cost_per_weight: string;
  sum_prc_dlvr_margin_all_details: string;
  sum_price_n_delivery: string;
  sum_price_n_delivery_eur: string;
  sum_price_n_delivery_with_margin: string;
}

export interface ILoadOrderDetail {
  id: number;
  invoice_id: number;
  order: {
    shop: IShop;
  }
  margin: string;
  total: string;
  price: string;
  size: string;
  color: string;
  comment: string;
  image_path: string[];
}


export interface IEditInvoice {
  price: string;
  shipping_cost: string;
  sum_price_n_delivery: string;
  sum_price_n_delivery_with_margin: string;
  price_eur: string;
  weight: string;
  shipping_cost_per_weight: string;
  payment_amount_eur: string;
  invoice_details: IEditInvoiceDetail[];
  currency_id?:string
}

export interface IEditInvoiceDetail {
  id: number;
  price: string;
  shipping_cost: string;
  sum_price_n_delivery: string;
  sum_price_n_delivery_with_margin: string;
  sum_price_n_delivery_eur: string;
  weight: string;
  margin: string;
  price_per_kg: string;
  shipping_cost_per_weight: string;
  total: string;
  exchange_rate: any;
  arrived: number;
}